const {
  parseBudgetedHours,
} = require('../../helpers/workInstructions/budgetedHours');

class WorkInstructionPackageDTO {
  _id;
  title;
  category;
  productLine;
  originalOEM;
  frameType;
  model;
  partNumber;
  documentNumber;
  revision;
  sapReference;
  description;
  status;
  owner;
  version;
  favoriteCount;
  isStandard;
  type;
  workInstructions;
  jobId;
  sortOrder;
  budgetedHours;
  createdAt;
  updatedAt;
  deleted;
  deletedAt;

  constructor(data = {}) {
    const coerceDisplayValue = (value) => {
      if (Array.isArray(value)) {
        return coerceDisplayValue(value[0]);
      }

      if (value && typeof value === 'object') {
        return (
          value.name ||
          value.text ||
          value.value ||
          value.label ||
          value.Model ||
          value.OriginalOEM ||
          ''
        );
      }

      return value == null ? '' : String(value);
    };

    const getFirstAvailableValue = (source, keys) =>
      keys
        .map((key) => coerceDisplayValue(source?.[key]))
        .find((normalizedValue) => normalizedValue !== '');

    const parseBoolean = (value, fallback = false) => {
      if (typeof value === 'boolean') return value;
      if (typeof value === 'string') return value.toLowerCase() === 'true';
      if (typeof value === 'number') return value === 1;
      return fallback;
    };

    const parseNumber = (value, fallback = 0) => {
      if (typeof value === 'number' && !Number.isNaN(value)) return value;
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    this._id = data._id || data.id;
    this.title = data.title;
    this.category = data.category;
    this.productLine = getFirstAvailableValue(data, [
      'productLine',
      'ProductLine',
    ]);
    this.originalOEM = getFirstAvailableValue(data, [
      'originalOEM',
      'OriginalOEM',
      'originalOem',
      'originalOEMBrand',
    ]);
    this.frameType = getFirstAvailableValue(data, ['frameType', 'FrameType']);
    this.model = getFirstAvailableValue(data, ['model', 'Model', 'modelName']);
    this.partNumber = getFirstAvailableValue(data, [
      'partNumber',
      'PartNumber',
    ]);
    this.documentNumber = getFirstAvailableValue(data, [
      'documentNumber',
      'DocumentNumber',
    ]);
    this.revision = data.revision;
    this.sapReference = getFirstAvailableValue(data, [
      'sapReference',
      'SAPReference',
    ]);
    this.description = data.description;
    this.status = data.status;
    this.owner = data.owner;
    this.version = data.version || data.revision;
    this.favoriteCount = parseNumber(data.favoriteCount, 0);
    this.isStandard = parseBoolean(data.isStandard, false);
    this.type = data.type;
    this.workInstructions = Array.isArray(data.workInstructions)
      ? data.workInstructions
      : [];
    this.jobId = data.jobId;
    this.sortOrder = parseNumber(data.sortOrder, 0);
    this.budgetedHours = parseBudgetedHours(data.budgetedHours);
    this.createdAt = data.createdAt;
    this.updatedAt =
      data.updatedAt || data.modified || data._md || data.createdAt;
    this.deleted = parseBoolean(data.deleted, false);
    this.deletedAt = parseNumber(data.deletedAt, 0);
  }
}

module.exports = WorkInstructionPackageDTO;
